import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function RecruitingStrip() {
    return (
        <section className="mm-section bg-mm-cream" data-testid="recruiting-strip">
            <div className="mm-container">
                <div className="relative mm-card overflow-hidden p-10 sm:p-14">
                    <div
                        aria-hidden
                        className="absolute inset-0 bg-gradient-to-br from-mm-navy via-mm-navy to-mm-blue"
                    />
                    <div
                        aria-hidden
                        className="absolute -top-20 right-0 h-60 w-60 rounded-full bg-mm-sky/30 blur-3xl"
                    />
                    <div className="relative grid gap-8 md:grid-cols-[1.5fr_1fr] md:items-center">
                        <div>
                            <div className="mm-eyebrow !text-mm-sky mb-3">Careers</div>
                            <h2 className="mm-display text-4xl sm:text-5xl leading-[1.05] text-white">
                                Join the Team and Change Your Life Forever.
                            </h2>
                            <p className="mt-5 max-w-xl text-white/80">
                                Work virtually. Build real relationships. Be mentored
                                by licensed agents who actually care about your growth.
                            </p>
                        </div>
                        <div className="flex flex-col gap-3 md:items-end">
                            <Link
                                to="/join"
                                className="mm-btn-primary !bg-white !text-mm-navy hover:!bg-mm-sky hover:!text-mm-navy"
                                data-testid="recruiting-cta"
                            >
                                Learn About Joining
                                <ArrowRight size={16} />
                            </Link>
                            <span className="text-xs text-white/60">
                                Results not guaranteed.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
